import { Component, OnInit } from '@angular/core';
import { GeneratorService } from '../generator.service';

@Component({
  selector: 'cygov-generator-vendor-settings',
  templateUrl: './vendor-settings.component.html',
  styleUrls: ['./vendor-settings.component.scss']
})
export class VendorSettingsComponent implements OnInit {

  constructor(
    public service: GeneratorService,
  ) { }

  ngOnInit() {
  }

}
